import { NavigationGuardContext } from "@/providers/NavGuardProvider";
import type { NavigationGuardProviderProps } from "@/types/providers/navigationGuard";
import { useContext } from "react";

export default function useNavigationGuard() {
  const context = useContext(NavigationGuardContext) as NavigationGuardProviderProps;
  if (!context) throw new Error("useNavigationGuard must be used within an NavGuardProvider");
  return context;
}
